const url = `/Areas/AcuraPlatform/fonts`;

export const appFonts = {
  // AcuraBespoke
  AcuraBespokeRegular: {
    fontFamily: `AcuraBespoke`,
    src: `url(${url}/acura_bespoke-regular.woff)`,
    fontDisplay: 'swap',
  },
  AcuraBespokeLight: {
    fontFamily: `AcuraBespokeLight`,
    src: `url(${url}/acura_bespoke-light.woff)`,
    fontDisplay: 'swap',
  },

  // Avenir @Deprecated
  AvenirLTProRoman: {
    fontFamily: `AvenirLTProRoman`,
    src: `url(${url}/AvenirLTPro-Roman.woff)`,
    fontDisplay: 'swap',
  },
  AvenirLTProHeavyOblique: {
    fontFamily: `AvenirLTProHeavyOblique`,
    src: `url(${url}/AvenirLTPro-HeavyOblique.woff)`,
    fontDisplay: 'swap',
  },
  AvenirLTProBook: {
    fontFamily: `AvenirLTProBook`,
    src: `url(${url}/AvenirLTPro-Book.woff)`,
    fontDisplay: 'swap',
  },
  AvenirLTProBookOblique: {
    fontFamily: `AvenirLTProBookOblique`,
    src: `url(${url}/AvenirLTPro-BookOblique.woff)`,
    fontDisplay: 'swap',
  },
  AvenirLTProHeavy: {
    fontFamily: `AvenirLTProHeavy`,
    src: `url(${url}/AvenirLTPro-Heavy.woff)`,
    fontDisplay: 'swap',
  },
  AvenirLTProLight: {
    fontFamily: `AvenirLTProLight`,
    src: `url(${url}/AvenirLTPro-Light.woff)`,
    fontDisplay: 'swap',
  },
  AvenirLTProMedium: {
    fontFamily: `AvenirLTProMedium`,
    src: `url(${url}/AvenirLTPro-Medium.woff)`,
    fontDisplay: 'swap',
  },
  // Monotype Fonts
  AvenirNextBold: {
    fontFamily: `AvenirNextBold`,
  },
  AvenirNextDemi: {
    fontFamily: `AvenirNextDemi`,
  },
  AvenirNextRegular: {
    fontFamily: `AvenirNextRegular`,
  },
  AvenirNextMedium: {
    fontFamily: `AvenirNextMedium`,
  },
  AvenirNextLight: {
    fontFamily: `AvenirNextLight`,
  },
};
